import React, {Component, Fragment} from 'react';
import {Redirect} from "react-router";
import img from "../../Assets/Img/payment_fail.svg";
import {Link} from "react-router-dom";
import FullScreenLoader from "../Common/FullScreenLoader";

class PaymentFail extends Component {
    constructor() {
        super();
        this.state={
            isLoading:"d-none",
            Redirect:false
        }
    }
    pageRedirect=()=>{
        if(this.state.Redirect===true){
            return(
                <Redirect to="/otp"/>
            )
        }
    }
    render() {
        return (
            <Fragment>
                <div className="container ">
                    <div className="row d-flex animated zoomIn justify-content-center">
                        <div className="col-md-10 my-4 col-lg-10 col-12 col-sm-12">
                            <div className="container shadow-sm p-2 bg-white">
                                <div className="row d-flex justify-content-center">
                                    <div className="col-md-4 text-center login-form col-lg-4 col-sm-8 col-12  ">
                                        <img className="w-50" src={img}/>
                                        <Link to="/orderHistory" className="btn my-3 btn-dark">ক্রয়ের ইতিহাস চেক করুন</Link>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.pageRedirect()}
                <FullScreenLoader isLoading={this.state.isLoading}/>
                <br/><br/><br/><br/><br/><br/><br/>
            </Fragment>
        );
    }
}

export default PaymentFail;